import React from 'react'
import { Box, Button, VStack, Text, Code, Heading } from '@chakra-ui/react'
import { useAuth } from '../contexts/AuthContext'

export function AuthDebugPanel() {
  const { user, isAuthenticated, isLoading, login, logout, getAccessToken } = useAuth()

  const handleTestToken = async () => {
    try {
      const token = await getAccessToken()
      console.log('Access token:', token)
      alert(`Token: ${token ? 'Retrieved successfully (check console)' : 'Failed to get token'}`)
    } catch (error) {
      console.error('Error getting token:', error)
      alert('Error getting token (check console)')
    }
  }

  return (
    <Box p={4} borderWidth={1} borderRadius="md" bg="gray.50">
      <Heading size="sm" mb={3}>Auth Debug Panel</Heading>
      <VStack align="start" spacing={2}>
        <Text>
          <strong>Loading:</strong> {isLoading ? 'Yes' : 'No'}
        </Text>
        <Text>
          <strong>Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}
        </Text>
        {user && (
          <>
            <Text><strong>User ID:</strong> {user.id}</Text>
            <Text><strong>Name:</strong> {user.name}</Text>
            <Text><strong>Email:</strong> {user.email}</Text>
          </>
        )}
        <Text fontSize="sm" color="gray.600">
          <strong>Auth Mode:</strong> Backend Proxy (Regular Web App)
        </Text>
        <Code fontSize="xs" p={2} borderRadius="md" w="full">
          {JSON.stringify({ isAuthenticated, user }, null, 2)}
        </Code>
        <VStack spacing={2} pt={2}>
          {!isAuthenticated ? (
            <Button onClick={login} colorScheme="blue" size="sm">
              Login via Backend
            </Button>
          ) : (
            <>
              <Button onClick={logout} colorScheme="red" size="sm">
                Logout
              </Button>
              <Button onClick={handleTestToken} colorScheme="green" size="sm">
                Test Get Token
              </Button>
            </>
          )}
        </VStack>
      </VStack>
    </Box>
  )
}
